import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { ActionCard } from "@avenue-8/sidekick-ui";
import { ChatMessageArtifact } from "@store/messages.store";

type WidgetKind = Extract<ChatMessageArtifact["kind"], `widget-${string}`>;

const fallbackLabels: Partial<Record<WidgetKind, string>> = {
  "widget-cma-details": "CMA Details",
  "widget-listing-details": "Listing Details",
  "widget-listings-search": "Listings Search",
};

const getFallbackLabel = (kind: WidgetKind): string =>
  fallbackLabels[kind] ??
  kind
    .replace(/^widget-/, "")
    .split("-")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

type WidgetArtifact = ChatMessageArtifact & {
  kind: WidgetKind;
  title?: string;
};

const getArtifactTitle = (artifact: WidgetArtifact): string =>
  artifact.title ?? getFallbackLabel(artifact.kind);

type Props = {
  artifact: WidgetArtifact;
  onClick: (artifact: ChatMessageArtifact) => void;
};

export const WidgetArtifactCard = ({ artifact, onClick }: Props) => (
  <ActionCard
    title={getArtifactTitle(artifact)}
    icon={<ArticleOutlinedIcon fontSize="small" />}
    onClick={() => onClick(artifact)}
  />
);
